<template>
  <ais-stats>
    <template v-slot="{ page, nbHits }">
      <span class="font-montserrat text-sm font-regular font-university-primary"
        >Showing 1 - {{ pageRangeEnd(page, nbHits) }} of {{ nbHits }} Results</span
      >
    </template>
  </ais-stats>
</template>
<script setup>
import { AisStats } from "vue-instantsearch/vue3/es";
import { useSearchClient } from "@/composables/useSearchClient";

const { getHitsPerPage } = useSearchClient();

const pageRangeStart = (page) => {
  return page * getHitsPerPage() + 1;
};

const pageRangeEnd = (page, totalResults) => {
  const endResult = (page + 1) * getHitsPerPage();
  return endResult > totalResults ? totalResults : endResult;
};
</script>
